"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterElementsSelectError = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
/**
 * Component that displays a generic error message.
 * @beta
 */
exports.AttributeFilterElementsSelectError = function () { return (react_1.default.createElement(sdk_ui_kit_1.Message, { type: "error" },
    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "gs.list.error" }))); };
//# sourceMappingURL=AttributeFilterElementsSelectError.js.map